import React, { useEffect, useState } from "react";
import { Table } from "antd";

function TailorDetail({ allData }) {
  console.log(allData)
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(allData);
  }, [allData]);

  const columns = [
    {
      title: "Name",
      dataIndex: ["shop", "name"],
      key: "name",
    },
    {
      title: "Working Days",
      dataIndex: ["shop", "workingDays"],
      key: "workingDays",
    },
    {
      title: "Items",
      key: "items",
      render: (text, record) =>
        record.items && record.items.length > 0 ? (
          <ul>
            {record.items.map((item) => (
              <li key={item.id}> {/* Use a unique identifier if available */}
                <strong>Name:</strong> {item.name}, &nbsp;
                <strong>Selling Price:</strong> {item.sellingPrice}, &nbsp;
                <strong>Daily Income:</strong> {item.dailyIncome}, &nbsp;
                <strong>Daily Purchase:</strong> {item.dailyPurchase}, &nbsp;
                <strong>Morning Price:</strong> {item.morningPrice}, &nbsp;
                <strong>Morning Sale:</strong> {item.morningSale}, &nbsp;
                <strong>Net Quantity:</strong> {item.netQuantity}, &nbsp;
                <strong>Selling Income:</strong> {item.sellingIncome}, &nbsp;
                <strong>Wastage:</strong> {item.wastage}
              </li>
            ))}
          </ul>
        ) : (
          "No items available"
        ),
    },
  ];

  return (
    <div className="container-fluid">
      {/* <h5 className="">Name: {data[0]?.shop?.name}</h5> */}
      <Table 
        columns={columns} 
        dataSource={data} 
        rowKey={(record) => record.shop?.name} // Use a unique identifier if available
        pagination={false}  // Add pagination if needed
      />
    </div>
  );
}

export default TailorDetail;
